<script setup lang="ts">
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";

defineProps<{
  title: string;
  label?: string;
}>();
</script>

<template>
  <button
    type="button"
    class="option-btn w-100 rounded"
    data-bs-auto-close="true"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    <div class="w-100 d-flex justify-content-between align-items-center">
      <div class="col d-flex flex-column align-items-start">
        <div class="text-truncate text-grey">
          <small>{{ title }}</small>
        </div>
        <div v-if="label" class="text-truncate">
          {{ label }}
        </div>
      </div>
      <PhosphorIcon
        name="caret-down"
        :size="16"
        style="transition: transform 0.2s ease-in-out"
      />
    </div>
  </button>
</template>

<style lang="scss" scoped></style>
